function bindIFrameCloseButton() {
  $('.close-icon').click(function(){
    $('.iframe-overlay').remove();
  });
}

function showIFrameAfterDelay(delay) {
  setTimeout(function(){
    $('.iframe-overlay').fadeIn(500);
  }, delay);
}


/*** EXPORTS FROM exports-loader ***/
exports["bindIFrameCloseButton"] = (bindIFrameCloseButton);
exports["showIFrameAfterDelay"] = (showIFrameAfterDelay);